export default "__VITE_ASSET__089aab55__"